export const JUPAS_GUEST_RESUME_KEY = 'edvise_jupas_guest_resume';
export const JUPAS_GUEST_NOTICE_SEEN_KEY = 'edvise_jupas_guest_notice_seen';

export function cacheJupasGuestState({ scores, selectedProgrammes, activeStep }) {
  if (typeof window === 'undefined') return;
  const payload = {
    version: 1,
    scores: (scores || [])
      .filter((row) => row?.subjectCode && row?.score)
      .map(({ subjectCode, score }) => ({ subjectCode, score })),
    selectedProgrammes: Array.isArray(selectedProgrammes) ? selectedProgrammes : [],
    activeStep,
  };
  sessionStorage.setItem(JUPAS_GUEST_RESUME_KEY, JSON.stringify(payload));
}

export function readJupasGuestState() {
  if (typeof window === 'undefined') return null;
  try {
    const parsed = JSON.parse(sessionStorage.getItem(JUPAS_GUEST_RESUME_KEY) || 'null');
    return parsed?.version === 1 ? parsed : null;
  } catch {
    sessionStorage.removeItem(JUPAS_GUEST_RESUME_KEY);
    return null;
  }
}

export function clearJupasGuestState() {
  if (typeof window === 'undefined') return;
  sessionStorage.removeItem(JUPAS_GUEST_RESUME_KEY);
}
